import React from 'react'
import { lighten } from 'polished'

// STYLES
import styled from 'styled-components'

const Button = ({bgColor, color, size, text, className}) => <input type='button' className={className} value={text} />

const ButtonWithStyles = styled(Button)`
    background-color: ${(props) => props.bgColor};
    padding: 15px 30px;
    border-radius: 5px;
    cursor: pointer;
    color: ${(props) => props.color};
    font-family: Dosis;
    font-size: 20px;
    font-weight: 600;
    text-align: center;
    outline: none;
    transition: all 0.3s ease;
    border: none;

    &:hover{
        background: ${(props) => lighten(0.05, props.bgColor)};
    }

    @media screen and (max-width: 575px) {
        font-size: 18px;
    }
`

export default ButtonWithStyles



// WEBPACK FOOTER //
// ./src/components/button/button.component.js